import { DropdownOption } from "component/CustomDropdown";

export class PageSizeOption {
    static options: DropdownOption[] = [
        { id: 10, name: '10' },
        { id: 25, name: '25' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
    ];
}